import {externalApiURL} from '@logistics-frontend/client-core/api/corp'
import {addQuery} from '@logistics-frontend/utils'

import type {OffersCalculateRequest, OffersCalculateResponse} from 'src/shared/types'

import {appConfig} from '../../config'
import {fetch} from '../fetch'

export function fetchOffersCalculate(body: OffersCalculateRequest): Promise<OffersCalculateResponse> {
  // return import('./fetch-offers-calculate.json').then(r => r.default as OffersCalculateResponse)
  return fetch<OffersCalculateRequest, OffersCalculateResponse, OffersCalculateResponse>({
    method: 'POST',
    url: addQuery(externalApiURL('phoenix/dcaa/cargo/v1/offers/calculate'), {country: appConfig.countryCode}),
    body,
  })
}
